import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { AdminOverview } from "@/features/admin/components/admin-overview";
import { PageContainer } from "@fleet/ui";

function AdminIndexPage() {
  return (
    <PageContainer maxWidth="6xl">
      <AdminOverview />
    </PageContainer>
  );
}

export const adminIndexRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/",
  component: AdminIndexPage,
});
